module.exports = __webpack_public_path__ + "img/qr-hscz.922c1e6.922c1e69.png";